var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserCheckGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#475B7F",
    d: "M22.685 8.746a.406.406 0 01-.003.568l-4.769 4.731a.4.4 0 01-.566-.002l-.001-.001-2.757-2.778a.4.4 0 01.002-.566h.001l.948-.942a.4.4 0 01.566.002l.001.001 1.536 1.546 3.537-3.51a.4.4 0 01.566.002l.001.001.938.948z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M8.76 12a4.32 4.32 0 100-8.64 4.32 4.32 0 000 8.64zm3.024 1.08h-.564c-1.56.72-3.36.72-4.92 0h-.564A4.537 4.537 0 001.2 17.616v1.404c0 .895.725 1.62 1.62 1.62H14.7a1.62 1.62 0 001.62-1.62v-1.404.001a4.537 4.537 0 00-4.535-4.537h-.001z"
  }))));
}

export default SvgUserCheckGray;